import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app';

export const initializeCapacitorPlugins = async () => {
  if (Capacitor.isNativePlatform()) {
    // Configure status bar
    await StatusBar.setStyle({ style: Style.Default });
    await StatusBar.setBackgroundColor({ color: '#ffffff' });

    // Hide splash screen after app is ready
    await SplashScreen.hide();

    // Handle back button on Android
    App.addListener('backButton', ({ canGoBack }) => {
      if (!canGoBack) {
        App.exitApp();
      } else {
        window.history.back();
      }
    });
  }
};

export const hideSplashScreen = async () => {
  if (Capacitor.isNativePlatform()) {
    await SplashScreen.hide();
  }
};

export const setStatusBarStyle = async (isDark: boolean) => {
  if (Capacitor.isNativePlatform()) {
    await StatusBar.setStyle({
      style: isDark ? Style.Dark : Style.Light
    });
  }
};
